// NATIVE 
import * as React from 'react';


// INSTALLED 
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu, { MenuProps } from '@mui/material/Menu';
import { styled, alpha  } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Card, Chip, Pagination, TablePagination } from '@mui/material';


// CUSTOM 
import { SnackAlert } from '../SnackAlert';
import MultipleSnackbars from '../MultipleSnackbars';
import { paddingCardsTables, timeToClosedToast } from '../../commons';
import { showNumberRowsTable } from '../../commons/utils/values';
import { EditDialogTurno } from '../modals/turnos/EditDialogTurno';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import { DetailDialogTurno } from '../modals/turnos/DetailDialogTurno';
import { CreateDialogTurno } from '../modals/turnos/CreateDialogTurno';
import { closeSessionGlobal, hasPemissions } from '../../commons/utils';
import { getShiftsStore, getTurnosByPagination, storeActiveTurno, storeDesactiveTurno, storeDetailTurno } from '../../store/shifts';









const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.secondary.contrastText,
    fontSize: 15,
    fontWeight: 700
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));






/**
 * TableTurnos component is responsible for displaying a table of shifts (turnos) with various functionalities
 * such as pagination, viewing details, editing, deactivating, and restoring shifts.
 *
 * @component
 *
 * @example
 * return (
 *   <TableTurnos />
 * )
 *
 * @returns {JSX.Element} The rendered TableTurnos component.
 *
 * @remarks
 * This component uses Redux for state management and Material-UI for UI components.
 * It fetches the list of shifts from the Redux store and displays them in a table with pagination.
 * It also provides functionalities to view details, edit, deactivate, and restore shifts based on user permissions.
 *
 * @requires
 * - `useDispatch` from 'react-redux'
 * - `useSelector` from 'react-redux'
 * - `React` from 'react'
 * - `styled` from '@mui/material/styles'
 * - `Menu`, `MenuItem`, `Button`, `Chip`, `Card`, `TableContainer`, `Paper`, `Table`, `TableHead`, `TableRow`, `TableBody`, `TablePagination`, `Box`, `Pagination` from '@mui/material'
 * - `KeyboardArrowDownIcon`, `VisibilityIcon`, `DeleteIcon` from '@mui/icons-material'
 * - `getShiftsStore`, `storeDetailTurno`, `storeDesactiveTurno`, `storeActiveTurno`, `getTurnosByPagination` from 'path-to-actions'
 * - `hasPemissions`, `validateResponse`, `validateLsPermissions`, `closeSessionGlobal` from 'path-to-utils'
 * - `ModalSessionExpired`, `MultipleSnackbars`, `SnackAlert`, `CreateDialogTurno`, `DetailDialogTurno`, `EditDialogTurno` from 'path-to-components'
 *
 * @state {Array} dataTableList - The list of shifts to be displayed in the table.
 * @state {Object} pagination - The pagination information for the table.
 * @state {number} page - The current page number for the table.
 * @state {number} rowsPerPage - The number of rows per page for the table.
 * @state {number} pagePagination - The current page number for the pagination component.
 * @state {number} itemCountPagination - The total number of pages for the pagination component.
 * @state {Array} msgErrors - The list of error messages.
 * @state {any} openElem - The currently open element in the table.
 * @state {any} anchorEl - The anchor element for the menu.
 * @state {string} message_alert_snack - The message for the alert snackbar.
 * @state {string} type_alert_snack - The type of the alert snackbar.
 * @state {boolean} open_cargo - The state to control the open/close of the create cargo modal.
 * @state {boolean} buttons - The state to control the buttons.
 * @state {boolean} modalDetalleTurno - The state to control the open/close of the detail turno modal.
 * @state {boolean} modalEditarCargo - The state to control the open/close of the edit cargo modal.
 * @state {boolean} canEdit - The state to control the edit permission.
 * @state {boolean} canDelete - The state to control the delete permission.
 * @state {boolean} canRestore - The state to control the restore permission.
 * @state {number} timeAlert - The duration for the alert snackbar.
 * @state {Array} messagesAlerts - The list of alert messages.
 * @state {boolean} modalSessionExpired - The state to control the open/close of the session expired modal.
 * @state {boolean} alert_snack - The state to control the open/close of the alert snackbar.
 * @state {Object} msgSnack - The message object for the alert snackbar.
 *
 * @function handleClick - Handles the click event for opening the menu.
 * @function handleClose - Handles the close event for closing the menu.
 * @function getDataShifts - Fetches the data for shifts.
 * @function openDialogDetalle - Opens the detail dialog for a shift.
 * @function openDialogEditar - Opens the edit dialog for a shift.
 * @function desactiveTurno - Deactivates a shift.
 * @function restoreTurno - Restores a shift.
 * @function handleCloseModalCrearCargo - Closes the create cargo modal.
 * @function handleCloseModalDetailTurno - Closes the detail turno modal.
 * @function handleCloseModalEditarCargo - Closes the edit cargo modal.
 * @function totalHours - Calculates the total hours between start and finish times.
 * @function handleChangeRowsPerPage - Handles the change event for rows per page in the table.
 * @function handleChangePage - Handles the change event for page number in the table.
 * @function changePaginationPage - Handles the change event for pagination page number.
 * @function checkEdit - Checks if the user has edit permissions.
 * @function checkCanDelete - Checks if the user has delete permissions.
 * @function checkRestore - Checks if the user has restore permissions.
 * @function validateLsPermissions - Validates the local storage permissions.
 * @function validateResponse - Validates the response from the server.
 */
export const TableTurnos = () => {
    
    


    // DISPATCH 
    const dispatch = useDispatch();

  
    // REDUX
    const  {  turnos_list, turno }:any  = useSelector( (state:any) => state.turnos );


    // USE STATE
    const [dataTableList, setDataTable] = React.useState([]);
    const [pagination, setPagination] = React.useState<any>({
        "page": 1,
        "take": 1,
        "itemCount": 1,
        "pageCount": 1,
        "hasPreviousPage": false,
        "hasNextPage": false
    });

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);
    const [pagePagination, setPagePagination] = React.useState(1);
    const [itemCountPagination, setItemCountPagination] = React.useState(1);
   
   
    const [msgErrors, setMsgErrors] = React.useState([]);
      
    const [openElem, setOpenElem] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);


    const [message_alert_snack, setMessageAlertSnack] = React.useState('');
    const [type_alert_snack, setTypeAlertSnack] = React.useState('success');


    const [open_cargo, setOpenCargo]     = React.useState(false);
    const [buttons, setButtons] = React.useState(false);
    const [modalDetalleTurno, setModalDetalleTurno] = React.useState(false);
    const [modalEditarCargo, setModalEditar] = React.useState(false);



    const [canEdit, setCanEdit]     = React.useState<boolean>(false);
    const [canDelete, setCanDelete]     = React.useState<boolean>(false);
    const [canRestore, setCanRestore]     = React.useState<boolean>(false);


    const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
    const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);
    const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);
    
    const [alert_snack, setAlertSnack] = React.useState(false);
    const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
    });
   
   
   
    // USE EFFECT
    React.useEffect(() => {
      
      if ( turnos_list.data && turnos_list.data.length > 0 ) {

        setDataTable(turnos_list.data);
        setPagination({
          "page": turnos_list.meta.page,
          "take": turnos_list.meta.take,
          "itemCount": turnos_list.meta.itemCount,
          "pageCount": turnos_list.meta.pageCount,
          "hasPreviousPage": turnos_list.meta.hasPreviousPage,
          "hasNextPage": turnos_list.meta.hasNextPage
        });
        setItemCountPagination(turnos_list.meta.pageCount);
        
      }
      

    }, [turnos_list]);


     // HERE LOAD THE DATA NECESARY FOR CREATE SHIFTS 
    React.useEffect( () => {
      getDataShifts();
    }, []);


    React.useEffect(() => {
      checkEdit()
    }, []);
  
    React.useEffect(() => {
        checkCanDelete()
    }, []);
  
    React.useEffect(() => {
      checkRestore()
    }, []);
    
  

    // CONST STYLES
    const StyledMenu = styled((props: MenuProps) => (
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...props}
      />
    ))(({ theme }) => ({
      '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
          theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
          'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
          padding: '7px 0',
        },
        '& .MuiMenuItem-root': {
          '& .MuiSvgIcon-root': {
            fontSize: 18,
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1.5),
          },
          '&:active': {
            backgroundColor: alpha(
              theme.palette.primary.main,
              theme.palette.action.selectedOpacity,
            ),
          },
        },
      },
    }));
        
        
    const Div = styled('div')(({ theme }) => ({
      ...theme.typography.button,
      backgroundColor: 'wheat',
      padding: theme.spacing(8),
      textAlign: 'center'
    }));

  

    // CONST VALUE
    const open = Boolean(anchorEl);
  
  
    // CONST FUNCTIONS
    const handleClick = (elem:any) => (event:any) => {
      setAnchorEl(event.currentTarget);
      setOpenElem(elem);
    };

  
    const handleClose = () => {
      setAnchorEl(null);
      setOpenElem(null);
    };
  


    const getDataShifts = async() => {
          
        const response = await dispatch( getShiftsStore() );

        const result = await validateResponse(response, ' (Listar Turnos) ');
        
  
    }


  
    const openDialogDetalle = async(turnoId:string) => {
        

      setAnchorEl(null);
      setOpenElem(null);
      setButtons(false);


      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'view');


      if( !havePermissions ){


        await validateLsPermissions('No tienes pemisos para (Desactivar) turno.');

  
        return false;

  
      }



      const response =  await dispatch( storeDetailTurno(turnoId) );

      const result = await validateResponse(response, ' (Ver Turno) ');

      if (!result) {
         return false;
      }


    
      setModalDetalleTurno(true);

    }

  
    const openDialogEditar = async(areaId:string) => {
        
         
      // await dispatch( storeDetailAreas(areaId) );
      await dispatch( storeDetailTurno(areaId) );
  
  
      setAnchorEl(null);
      setButtons(false);
      setModalEditar(true);
    }
  
  
    const desactiveTurno = async(turnoId:string) => {


      setAnchorEl(null);
      setOpenElem(null);
      setButtons(false);
      
      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'delete');


      if( !havePermissions ){


        await validateLsPermissions('No tienes pemisos para (Desactivar) turno.');

  
        return false;

  
      }

      
        
      const response = await dispatch( storeDesactiveTurno(turnoId) );

      const result = await validateResponse(response, '(Desactivar) turno.');

       
     
  
    }
  
  
    const restoreTurno = async(turnoId:string) => {


      setAnchorEl(null);
      setOpenElem(null);

      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'restore');


        if( !havePermissions ){
    

          await validateLsPermissions('No tienes pemisos para (Restaurar) turno.');
    
          return false;
                                                                    
        }
  
  
      const response = await dispatch( storeActiveTurno(turnoId) );


      // const dataUpdated:any = await updateStatusTableAndUpdateRedux( turnoId, 1, turnos_list);


      await validateResponse(response, '(Restaurar) turno.');



      // if( dataUpdated.ok ){
      //     await dispatch( setTurnosRedux(dataUpdated.data) );
      // }
  
      

  
    }
  
    
  
    const handleCloseModalCrearCargo = () => {
          setOpenCargo(false);
    }
  
    const handleCloseModalDetailTurno = () => {
         setModalDetalleTurno(false);
    }
  
    
    const handleCloseModalEditarCargo = () => {
         setModalEditar(false);
    }
  
  
    const totalHours = ( start:any, finish:any ) => {

        // Convertir las horas en minutos totales
        const [horasInicio, minutosInicio] = start.split(":").map(Number);
        const [horasFin, minutosFin] = finish.split(":").map(Number);

        // Convertir las horas y minutos a minutos totales
        const minutosTotalesInicio = horasInicio * 60 + minutosInicio;
        const minutosTotalesFin = horasFin * 60 + minutosFin;

        // Calcular la diferencia en minutos
        let diferenciaMinutos = minutosTotalesFin - minutosTotalesInicio;

        // Si la diferencia es negativa, sumar 24 horas (1440 minutos)
        if (diferenciaMinutos < 0) {
            diferenciaMinutos += 24 * 60;
        }

        // Convertir los minutos totales de diferencia en horas y minutos
        const horasDiferencia = Math.floor(diferenciaMinutos / 60);
        const minutosDiferencia = diferenciaMinutos % 60;

        return `${horasDiferencia}, ${minutosDiferencia}`;
       
    }


    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {

      setRowsPerPage(+event.target.value);

      setPage(0);

    };



    const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
    };


    const changePaginationPage = async(event: React.ChangeEvent<unknown>, value: number) => {
                
        setPagePagination(value)
    
        const response =  await dispatch( getTurnosByPagination(value) );

        await validateResponse(response, '(Listar) turno.');

    };




    const checkEdit = async() => {
            
    
      const hasPermissionsEdit = await hasPemissions('modulo.thumano', 'modulo.turnos', 'edit');
    
      if ( hasPermissionsEdit ) {
            setCanEdit(true);
      }

    }
    
    
    const checkCanDelete = async() => {
        
        
        const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'delete');
        
        if ( havePermissions ) {
              setCanDelete(true);
        }
  
    }
    
    
    const checkRestore = async() => {
        
        const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'restore');
          
        if ( havePermissions ) {
              setCanRestore(true);
        }
  
    }



    const validateLsPermissions = async(message:string) => {
    
          const errors:any = {
            msg: message,
            status: 'error'
          };
        
          await setMsgSnack(errors);
          await setAlertSnack(true);
        
        
        }
    
    
        const validateResponse = async(response:any, textActionConcat: string) => {
            
            
            if (  response.code == 401  ) {
              await localStorage.removeItem('lastSelectedQypht');
              await closeSessionGlobal();
              setModalSessionExpired(true);
              return false;
            }
    
          
            // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
            if (!response.ok && response.code == 403 ) { 
    
            
              const errors:any = {
                msg: response.errors[0]+' '+textActionConcat,
                status: 'error'
              };
            
              await setMsgSnack(errors);
              await setAlertSnack(true);
    
            
              return false;
              
            }
    
            
            // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
            if (!response.ok && response.code == 400 ) { 
    
              const errors:any = [];
    
              response.errors.forEach( (element:any) => {
                  
                  errors.push({
                    type: 'error',
                    text: element
                  })
              });
    
                
              setMessagesAlerts(errors);
              return false;
    
            }
    
            return true;
          
      }
    
    
    return (
  
      <>
  
         <ModalSessionExpired  open={modalSessionExpired}  />
         <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
         <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>

  
          <CreateDialogTurno open={open_cargo} handleCloseModalCrearCargo={handleCloseModalCrearCargo} buttons={buttons}/>
          <DetailDialogTurno open={modalDetalleTurno} handleCloseModalDetailTurno={handleCloseModalDetailTurno} />
          <EditDialogTurno  open={modalEditarCargo} handleCloseModalEditarCargo={handleCloseModalEditarCargo} />
         
  
         {
              
              dataTableList.length > 0
                  
                ?
                <>

                <Card
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                    marginTop: paddingCardsTables
                  }}
                >
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>#</StyledTableCell>
                        <StyledTableCell >Nombre turno</StyledTableCell>
                        <StyledTableCell >cargo</StyledTableCell>
                        <StyledTableCell >Horas</StyledTableCell>
                        <StyledTableCell >Entrada</StyledTableCell>
                        <StyledTableCell >Salida</StyledTableCell>
                        <StyledTableCell >Tarifas</StyledTableCell>
                        <StyledTableCell >Dias aplica</StyledTableCell>
                        <StyledTableCell >Año</StyledTableCell>
                        <StyledTableCell >Estado</StyledTableCell>
                        <StyledTableCell >Acciones</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dataTableList
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((turno:any, index:any) => (
                        <StyledTableRow key={index+1}>
                          <StyledTableCell component="th" scope="row">
                            {index+1}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {turno.name}
                          </StyledTableCell>
                          <StyledTableCell >
                            {turno.position?.name || 'N/A'}
                          </StyledTableCell>

                          <StyledTableCell >
                            { totalHours( turno.hora_entrada, turno.hora_salida ) }
                          </StyledTableCell>

                          <StyledTableCell >
                            {turno.hora_entrada}
                          </StyledTableCell>
                          <StyledTableCell >
                            {turno.hora_salida}
                          </StyledTableCell>
                          <StyledTableCell >
                            {turno.tarifa}
                          </StyledTableCell>
                          <StyledTableCell >
                            {turno.tarifa}
                          </StyledTableCell>
                          <StyledTableCell >
                            {turno.year}
                          </StyledTableCell>
                          <StyledTableCell >
                            {
                              turno.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} />
                            }
                          </StyledTableCell>
                          <StyledTableCell  >
                                
                          
                          {
                          
                              <div> 
                                  <Button
                                    id={`demo-customized-button-${index+1}`}
                                    aria-controls={open ? `demo-customized-menu-${index+1}` : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    variant="text"
                                    disableElevation
                                    onClick={handleClick(turno)}
                                    endIcon={<KeyboardArrowDownIcon />}
                                  >
                                    Acciones
                                  </Button>
                                  <StyledMenu
                                      id={`demo-customized-menu-${index+1}`}
                                      MenuListProps={{
                                        'aria-labelledby': `demo-customized-button-${index+1}`,
                                      }}
                                      anchorEl={anchorEl}
                                      open={openElem === turno}
                                      onClose={handleClose}
                                    >
                                    
                                    {
                                      (turno.status) 
                                        ? <div>
                                          <MenuItem onClick={ () => openDialogDetalle(turno.id) }  disableRipple>
 
                                          <VisibilityIcon />
                                            Detalle 
                                          </MenuItem>
                                          {/* <Divider sx={{ my: 0.5 }} />
                                          <MenuItem onClick={ () => openDialogEditar() }  disableRipple>
                                            <EditIcon />
                                              Editar
                                          </MenuItem> */}
                                        </div>
                                        :
                                        ''
                                    }
                                    
                                    {
                                      
                                      (turno.status) 
                                      ?
                                        <div>
                                            {
                                              canDelete && 
                                                  <>
                                                     <Divider sx={{ my: 0.5 }} />
                                                     
                                                    <MenuItem onClick={ () => desactiveTurno(turno.id) } disableRipple>
                                                      <DeleteIcon />
                                                      Desactivar
                                                    </MenuItem>
                                                  </>
                                            }
                                        </div>
                                      :
                                      <div>
                                          {
                                             canRestore && 
                                                 <>
                                                  <Divider sx={{ my: 0.5 }} />
                                                  <MenuItem onClick={ () => restoreTurno(turno.id) } disableRipple>
                                                    <DeleteIcon />
                                                    Activar
                                                  </MenuItem>
                                                 </>
                                          }
                                      </div>
                                      
                                    }
                                    </StyledMenu>
                                </div>
                      
                          }
          
          
          
          
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                </Card>
                <TablePagination
                  rowsPerPageOptions={[5, 10]}
                  labelRowsPerPage={'Filas por pagina'}
                  labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} de  ${count} `}
                  component="div"
                  count={pagination.itemCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={ handleChangePage }
                  onRowsPerPageChange={ handleChangeRowsPerPage }
                />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 2,
                    marginBottom: 2
                  }}
                >
                <Pagination sx={{ justifyContent: 'center' }} color="primary" count={itemCountPagination} page={pagePagination} onChange={ changePaginationPage} showFirstButton showLastButton />
                </Box>
                </>
                
                :
                <Div>{"No hay turnos disponibles..."}</Div>
         }
  
  
         
         
      </>
      
    );
}
